<template>
  <!-- 人员级资产管理 -> 企业云产品管理 -->
  <div class="property application-manage relative" id="table-wrapper" v-loading="loading">
    <div class="ui-fixed tree-table fit flex flex-column table-medium table-beyond-hiding" style="height: 100%;" id="tree-table" v-if="Array.isArray(data) && data.length">
      <div class="header-wrapper" ref="headerWrapper">
        <div class="table-header flex flex-row" style="width: 100%;">
          <div class="header-item is-leaf flex-1">企业云产品名称</div>
          <div class="header-item is-leaf flex-1">成员</div>
          <div class="header-item is-leaf is-operate" style="width: 160px;">管理权限</div>
          <div class="has-gutter" v-if="scrollY"></div>
        </div>
      </div>
      <div class="body-wrapper flex-1" style="overflow: auto;" ref="bodyWrapper">
        <ul class="container" style="width: 100%;" ref="containerWrapper">
          <li class="flex flex-row row row--level-1" v-for="(item, index) in data" :key="index">
            <div class="cell column_1 flex-1">
              <p class="app-name">
                <template v-if="item.permissionId && iconList && iconList[item.permissionId] && iconList[item.permissionId].src">
                  <span class="app-icon" :style="{backgroundImage: 'url(' + iconList[item.permissionId].src + ')'}"></span>
                </template>
                {{item.name}}
              </p>
            </div>
            <div class="cell column_1 flex-1">
              <p v-if="item.memberArray.length === 0">
                您尚未分配计价依据资产，请到
                <router-link :to="{path: '/manage/members'}">人员管理</router-link>
                页面进行操作
              </p>
              <span v-else-if="item.memberArray.length <= 3">
                {{item.memberArray.join('、')}}
              </span>
              <el-tooltip v-else class="item" effect="dark" placement="bottom">
                <span>
                  {{item.memberArray.slice(0, 3).join('、') + `等${item.memberArray.length}个成员`}}
                </span>
                <template slot="content">
                  <w-scrollbar wrap-style="overflow-x: hidden;" style="height: 200px;" v-if="item.member.length > 8">
                    <ul>
                      <li class="asset-item padding-top-5" v-for="(asset, idx) in item.member" :key="'asset-' + idx">
                        {{asset.name}}
                      </li>
                    </ul>
                  </w-scrollbar>
                  <ul v-else>
                    <li class="asset-item padding-top-5" v-for="(asset, idx) in item.member" :key="'asset-' + idx">
                      {{asset.name}}
                    </li>
                  </ul>
                </template>
              </el-tooltip>
            </div>
            <div class="cell column_1 is-operate" style="width: 160px;">
              <div style="width: 100%;">
                <span class="cursor-pointer margin-right-10" v-if="item.manager.name">
                  {{item.manager.name}}
                </span>
                <span class="color-red cursor-pointer margin-right-10" v-else>
                未分配
              </span>
                <w-dropdown @command="handlerAction" @click.native="sentLog(100111002)">
                  <w-button type="minor" style="padding: 2px 1px; height: 20px">
                    <i class="r2-icon-nav_arrow_drop_down" style="font-size: 16px !important; lineHeight: 15px;"></i>
                  </w-button>
                  <w-dropdown-menu slot="dropdown">
                    <w-scrollbar wrap-style="overflow-x: hidden;" style="height: 200px;" v-if="item.member.length > 8">
                      <w-dropdown-item v-for="(user, index) in item.member" :key="index"
                                       :style="{color: item.manager.userId === user.userId ? '#2079FA' : ''}"
                                       :command="{gldUserId: user.userId, permissionId: item.permissionId, name: user.name}">
                        {{user.name}}
                      </w-dropdown-item>
                    </w-scrollbar>
                    <template v-else>
                      <w-dropdown-item v-for="(user, index) in item.member" :key="index"
                                       :style="{color: item.manager.userId === user.userId ? '#2079FA' : ''}"
                                       :command="{gldUserId: user.userId, permissionId: item.permissionId, name: user.name}">
                        {{user.name}}
                      </w-dropdown-item>
                    </template>
                  </w-dropdown-menu>
                </w-dropdown>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="absolute text-align-center"
         style="top: 50%;left: 50%;transform: translate(-50%,-50%);">
      <div class="text-align-center color-white"
           style="width:56px;height:56px;line-height:56px;background:rgba(33,37,48,0.15);border-radius: 50%;margin: 0 auto;">
        <i class="r2-icon-action_lock" style="font-size: 30px;"></i>
      </div>
      <div class="text-align-center font-16 color-999" style="font-size:14px;margin-top: 12px">
        您尚未购买计价依据产品，请联系当地销售400-016-6166。
      </div>
    </div>
  </div>
</template>

<script>
import manageService from '@/assets/service/manage'

const iconList = {
  15: {
    src: require('@/assets/images/icon-jjyj.png'),
    name: '计价依据库'
  }
}
export default {
  name: 'ManageApplications',
  data () {
    return {
      scrollY: false,
      iconList,
      loading: false,
      maxHeight: '',
      columns: [
        {
          title: '企业云产品名称',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: {customRender: 'name'},
          width: 20
        },
        {
          title: '成员',
          dataIndex: 'member',
          key: 'member',
          scopedSlots: {customRender: 'member'},
          width: 20
        },
        {
          title: '管理权限',
          key: 'manager',
          dataIndex: 'manager',
          scopedSlots: {customRender: 'manager'},
          width: 5
        }
      ],
      data: []
    }
  },
  mounted () {
    setTimeout(() => {
      this.maxHeight = this.getTableHeight('table-wrapper')
    }, 200)
    this.resizeHandle.resize(() => {
      this.maxHeight = this.getTableHeight('table-wrapper')
    })
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      manageService.managementlist().then(res => {
        this.loading = false
        if (res.code === 200) {
          let items = res.data || []
          items.forEach(item => {
            item.member = item.member || []
            let memberArray = []
            item.member.forEach(item => {
              memberArray.push(item.name)
            })
            item.manager = item.manager || {}
            item.memberArray = memberArray
          })
          this.data = items
        } else {
          this.data = []
        }
      }).catch(() => {
        this.loading = false
        this.data = []
      })
    },
    // 操作列事件
    handlerAction ({permissionId, gldUserId, name}) {
      this.sentLog(100111003)
      this.$confirm({
        message: `您要将计价依据的管理权限赋予"${name}"用户吗？`,
        submit: () => {
          manageService.setauthority({permissionId, gldUserId}).then(res => {
            if (res.code === 200) {
              // this.$message.success('设置管理权成功');
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    }
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  }
}
</script>

<style lang="less" scoped>
  .property {
    padding: 24px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    &.application-manage{
      *{
        margin-bottom: 0;
      }
    }
    .app-name{
      padding-left: 46px;
      line-height: 34px;
      position: relative;
      .app-icon{
        position: absolute;
        left: 0;
        top: 0;
        display: inline-block;
        width: 34px;
        height: 34px;
        background-size: cover!important;
        background-repeat: no-repeat!important;
      }
    }
    .property-footer {
      height: 50px;
    }
  }
</style>
